module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('button', {
    staticClass: "add-user-button",
    on: {
      "click": _vm.showModalAddUser
    }
  }, [_vm._v("ADD NEW USER")]), _vm._v(" "), (_vm.showUserModal) ? _c('modal-user', {
    attrs: {
      "modal": _vm.showUserModal
    },
    on: {
      "update:modal": function($event) {
        _vm.showUserModal = $event
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('md-table', [_c('md-table-row', [_c('md-table-head', [_vm._v("USER EMAIL")]), _vm._v(" "), _c('md-table-head', [_vm._v("AUTHOR")]), _vm._v(" "), _c('md-table-head', [_vm._v("PERMISSION")]), _vm._v(" "), _c('md-table-head'), _vm._v(" "), _c('md-table-head')], 1), _vm._v(" "), _vm._l((_vm.userData), function(item, key) {
    return _c('md-table-row', {
      key: key
    }, [_c('md-table-cell', [_vm._v(_vm._s(item.email))]), _vm._v(" "), _c('md-table-cell', [_vm._v(_vm._s(item.defaultAuthor))]), _vm._v(" "), _c('md-table-cell', [_vm._v(_vm._s(item.permission))]), _vm._v(" "), _c('md-table-cell', [_c('modal-edituser', {
      attrs: {
        "passedItem": item
      }
    }, [_vm._v("EDIT USER")])], 1), _vm._v(" "), _c('md-table-cell', [_c('modal-deluser', {
      attrs: {
        "passedItem": item
      }
    }, [_vm._v("REMOVE USER")])], 1)], 1)
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-41c3c040"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/users.vue
// module id = 656
// module chunks = 1